import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { LEADS_MODULE_IDS } from "../../enums/leads";

const Leads = Loadable(
  lazy(() =>
    import("./LeadsTab").then(({ LeadsTabs }) => ({
      default: LeadsTabs,
    }))
  )
);

const ManageLead = Loadable(
  lazy(() =>
    import("./ManageLead/ManageLeadTabs").then(({ ManageLeadTabs }) => ({
      default: ManageLeadTabs,
    }))
  )
);

export const leadsRoutes = [
  {
    path: `/leads`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[LEADS_MODULE_IDS.LEADS]}>
        <Leads />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/leads/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[LEADS_MODULE_IDS.LEADS]}>
        <ManageLead />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/leads/manage/:leadId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[LEADS_MODULE_IDS.LEADS]}>
        <ManageLead />
      </AuthorizedRoute>
    ),
  },
];
